import React from 'react';
import { ScrollWithinBoxContextType } from '@components/ScrollWithinBox/types/ScrollWithinBoxContextType';

export const ScrollWithinBoxContext = React.createContext<ScrollWithinBoxContextType | null>(null);
